module.exports = __webpack_public_path__ + "youtube_squircle_charcoal.svg?b36e0a6cbfaea031ea366c597a15012c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/social/youtube_squircle_charcoal.svg
// module id = 298
// module chunks = 0